<template>
<el-dialog :close-on-click-modal="false" width="72%" :visible.sync="viewData.visible" class="rfq-dialog" @close="close" v-loading="loading">
    <div slot="title">
        <div v-if="this.dataForm && this.dataForm.rfqStatus">
            {{this.dataForm.rfqCode}} - {{ getRFQdispStatus(this.dataForm && this.dataForm.rfqStatus) }}
        </div>
        <div v-else>
            新增
        </div>
    </div>
    <!-- <H1 style="text-align:center">北京汽车制造厂（青岛）有限公司</H1> -->
    <!-- <H3 style="text-align:center">
        <el-input v-if="!dataForm.id" v-model="dataForm.projectName"></el-input>
        <span v-else>{{dataForm.projectName}}</span>
    </H3> -->
    <!-- 生产量纲 车型 汇率 零件名称 零件号 零件-单车用量 零件-装配比例 零件-供货比例 模具费支付方式 开发费支付方式 （开标时间 报价截止时间 时间。。。 供应商列表） 工厂编号 备注特殊要求-->
    <!-- 技术方案通过 -->
    <!-- <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="100px" class="org-dialog-form" size="small"> -->
    <el-tabs v-model="activeName" type="card" @tab-click="changeTab()">
        <el-tab-pane class="tab_style" key="basicInfo" label="基础信息" name="basicInfo">
            <rfq-tab-basic :basicFormData="dataForm" :viewFlag="viewFlag" @basicSubmit="dataFormSubmit()" :purchasePartyAList="purchasePartyAList" ref="basicInfo" />
        </el-tab-pane>
        <el-tab-pane class="tab_style" key="partList" label="零件列表" name="partList">
            <rfq-tab-part :basicFormData="dataForm" :viewFlag="viewFlag" :partList="partList" ref="partList" />
        </el-tab-pane>
        <el-tab-pane v-if="dataForm.rfqType !== '2'" class="tab_style" key="fileList" label="定点申请附件" name="fileList">
            <rfq-tab-file :bizId="technicalId" :viewFlag="viewFlag" :partList="partList" ref="fileList" />
        </el-tab-pane>
        <el-tab-pane v-if="dataForm.rfqType !== '2'" class="tab_style" key="techsupplierInfo" label="定点申请推荐供应商" name="techsupplierInfo">
            <rfq-tab-tech-supplier :basicFormData="dataForm" :supplierList="techsupplierList" :viewFlag="viewFlag" @refreshSupplierList="getSupplierList" @selectionChange="changeSelectSupplier" ref="techsupplierInfo" />
        </el-tab-pane>
        <el-tab-pane class="tab_style" key="supplierInfo" label="推荐供应商" name="supplierInfo">
            <rfq-tab-supplier :basicFormData="dataForm" :supplierList="supplierList" :techsupplierList="techsupplierList" :viewFlag="viewFlag" @refreshSupplierList="getSupplierList" @selectionChange="changeSelectSupplier" ref="supplierInfo" />
        </el-tab-pane>
        <el-tab-pane class="tab_style"  label="询价附件">
          <!-- TODO:上传下载 产看 需求文档 -->
          <FilesUpDown1 ref="FilesUpDown1" :bizId="dataForm.id" :bizType="FILE_BIZ_TYPE"></FilesUpDown1>
        </el-tab-pane>
       <!-- <el-tab-pane class="tab_style"  label="供应商附件">
          <FilesUpDown2 ref="FilesUpDown2" :bizId="technicalId" :bizType="FILE_BIZ_TYPE_SUPPLIER"></FilesUpDown2>
        </el-tab-pane>-->
        <el-tab-pane class="tab_style" key="partInfo" label="报价信息" name="partInfo" v-if="priceVisible">
            <rfq-tab-part-price :basicFormData="dataForm" :supplierList="supplierList" :viewFlag="viewFlag" :firstSupplierName="firstSupplierName" ref="partInfo" />
        </el-tab-pane>
        <el-tab-pane class="tab_style" key="compareInfo" label="比价信息" name="compareInfo" v-if="priceVisible || isShowComparePrice">
            <rfq-tab-compare :basicFormData="dataForm" :supplierList="supplierList" :viewFlag="viewFlag" :partList="partList" ref="compareInfo" />
        </el-tab-pane>
        <!--<el-tab-pane class="tab_style" key="appoveInfo" label="审批信息" name="appoveInfo" v-if="approveVisible">
            <rfq-tab-audit :basicFormData="dataForm" :supplierList="supplierList" :viewFlag="viewFlag" :partList="partList" ref="appoveInfo" />
        </el-tab-pane>-->
    </el-tabs>
    <!-- </el-form> -->
    <el-row :gutter="40" v-if="viewFlag">
        <el-col :span="24" style="text-align:right;">
            <el-button size="small" @click="close()">
                返回
            </el-button>
        </el-col>
    </el-row>
    <el-row :gutter="40" v-if="!viewFlag && this.dataForm.rfqStatus !== -1" class="mt20">
        <el-col :span="24" style="text-align:right;">
            <el-button size="small" @click="close()">
                取消
            </el-button>
            <!-- 询价开始 -->
            <el-tooltip v-if="dataForm.rfqStatus === RFQ_STATUS.BEGIN && isAuth('sourcing:rfq:newbutton')" class="item" effect="dark" content="采购点击暂存询价信息" placement="top">
                <!-- <el-button size="small" type="primary" @click="dataFormSubmit()"> -->
                <el-button size="small" type="primary" plain @click="savaBegin()">
                    暂存询价RFQ
                </el-button>
            </el-tooltip>
            <!-- 询价开始 询价结束 报价开始 追后一次询价结束 -->
            <!-- 第一次点击 询价中 -->
            <!-- 或者时间到了 供应商全部提交 -->
            <!-- TODO: 通知前设定供应商列表 注意供应商黑名单 -->
            <el-tooltip v-if="dataForm.rfqStatus === RFQ_STATUS.BEGIN && isAuth('sourcing:rfq:newbutton')" class="item" effect="dark" content="采购点击发布询价" placement="top">
                <el-button size="small" type="success" plain @click="informAsk()">
                    通知询价
                </el-button><!-- 询价开始-询价函 询价结束-报价函 -->
            </el-tooltip>
            <el-tooltip v-if="dataForm.rfqStatus === RFQ_STATUS.BEFORE_ASK && isAuth('sourcing:rfq:newbutton')" class="item" effect="dark" content="采购点击发送报价通知" placement="top">
                <!-- <el-button size="small" type="success" @click="makeRFQSubmit()"> -->
                <el-button size="small" type="success" plain @click="postAsk()">
                    报价通知
                </el-button><!-- 询价开始-询价函 询价结束-报价函 -->
            </el-tooltip>
            <!-- 采购员保存 -->
            <!-- <el-button v-if="(!dataForm.rfqStatus || dataForm.rfqStatus === RFQ_STATUS.REQSTART) && isAuth('sourcing:rfq:newbutton')" size="small" type="primary" @click="saveQuotation()">
                保存
            </el-button> -->
            <!-- 当到期或者全部供应商报价可以使用 -->
            <el-button v-if="dataForm.rfqStatus === RFQ_STATUS.ASKING && isAuth('sourcing:rfq:newbutton')" size="small" type="success" plain @click="checkQuotation()">
                查看报价
            </el-button>
            <!-- 采购员比价 -->
            <!-- 采购员发起延期报价 -->
            <el-button v-if="dataForm.rfqStatus === RFQ_STATUS.ASKING && isAuth('sourcing:rfq:newbutton')" size="small" type="danger" plain @click="delayQuotation()">
                延期报价
            </el-button>
            <!-- <el-button v-if="dataForm.rfqStatus === RFQ_STATUS.ASKING && isAuth('sourcing:rfq:newbutton')" size="small" type="success" @click="compareQuotation()">
                比价
            </el-button> -->
            <!-- 采购员发起下一轮 -->
            <!-- 没审批通过之前都可以发起下一轮 -->
            <el-button v-if="dataForm.rfqStatus === RFQ_STATUS.COMPARING && isAuth('sourcing:rfq:newbutton')" size="small" type="success" plain @click="preparedApprove()">
                拟定审批单
            </el-button>

           <!-- <el-button v-if="[RFQ_STATUS.COMPARING].includes(dataForm.rfqStatus) && isAuth('sourcing:rfq:newbutton')" size="small" type="primary" plain @click="tempQuotation()">
                暂存审批单
            </el-button>-->
            <!-- 采购员提交审批 -->
            <!--<el-button v-if="[RFQ_STATUS.COMPARING].includes(dataForm.rfqStatus) && isAuth('sourcing:rfq:newbutton')" size="small" type="success" plain @click="createApprove()">
                提交审批单
            </el-button>-->
            <el-button v-if="[RFQ_STATUS.COMPARING].includes(dataForm.rfqStatus) && isAuth('sourcing:rfq:newbutton') && isStartNext" size="small" type="primary" plain @click="nextQuotation()">
                发起下一轮
            </el-button>
            <!-- 批准 -->
            <!-- <span v-for="(item, index) in dataForm.taskActions" :key="index" style="margin-left:10px"> -->
            <!-- 存状态和workflowId -->
            <!-- <el-button v-if="item.flowRuleType && item.flowRuleType === 'action' && dataForm.rfqStatus === RFQ_STATUS.COMMITTED && isAuth('sourcing:rfq:newbutton')" size="small" type="success" @click="approve(item.taskId, item.flowRuleType, item.normalValue)">
                    批准
                </el-button> -->
            <!-- 采购员提交审批 -->
            <!-- 重新发起创建审批单， 发起下一轮 -->
            <!-- <el-button v-if="item.flowRuleType && item.flowRuleType === 'action' && dataForm.rfqStatus === RFQ_STATUS.COMMITTED && isAuth('sourcing:rfq:newbutton')" size="small" type="danger" @click="reject(item.taskId, item.flowRuleType, item.reverseValue)">
                    驳回
                </el-button> -->
            <!-- </span> -->
            <!-- 开标的时候采购可以看自己的 -->
            <!-- 校验合格供应商  -->
            <!-- 校验合格供应商，需要通知采购供应商走合格供应商流程，供应商完善信息，供应商管理员审批 -->
            <!-- <el-button v-if="dataForm.rfqStatus === RFQ_STATUS.APPROVED && isAuth('sourcing:rfq:newbutton')" size="small" type="success" @click="chooseFactory()">
                定厂通知书
            </el-button> -->
            <!-- 是否有价格协议 -->
            <!-- <el-button v-if="dataForm.rfqStatus === RFQ_STATUS.DECIDED && isAuth('sourcing:rfq:newbutton')" size="small" type="success" @click="makeContract()">
                生成合同&价格协议
            </el-button> -->
        </el-col>
    </el-row>
    <!-- 弹窗, 新增 / 修改 供应商-->
    <add-or-update-supplier v-if="addOrUpdateSupplierVisible" ref="addOrUpdateSupplier" @refreshSupplierDataList="getSupplierList"></add-or-update-supplier>
    <rfq-prepared-approve v-if="preparedVisible" :basicFormData="dataForm" :partList="partList" ref="rfqPreparedApprove" @confirm="confirmPrepare" />
    <quotation-delay-update v-if="quotationDelayUpdateVisible" ref="quotationDelayUpdate" @confirm="confirmDelayDate"></quotation-delay-update>
    <QuotationNextTime v-if="quotationNextTimeVisible" ref="quotationNextTime" @confirm="confirmNextDelayDate"></QuotationNextTime>
</el-dialog>
</template>

<script>
import {
    getRFQDetail,
    editRFQ,
    createRFQ,
    deleteRfqSupplier,
    getRfqSupplierList,
    getRfqPartList,
    getRfqSupplierByUserId,
    editRfqSupplierList,
    listPartCompare,
    getCurrentUserPurOrg
} from '@/controller/rfq'
import {
    generateAudit, getZBSupplierCountByRfqId
} from '@/controller/audit'
import {
    getTechSupplierList
} from '@/controller/tech'
import {
    getPurchaseOrgList
} from '@/controller/systemData'
import moment from 'moment'
import FilesUpDown1 from "@/views/common/file-up-down";
import FilesUpDown2 from "@/views/common/file-up-down";
import {
    USER_TYPE,
    RFQ_STATUS,
    getRFQ_STATUS_VALUE,
    getSUPPLY_RFQ_STATUS_VALUE,
    getSUPPLY_TYPE_VALUE,
} from '@/utils/const'
import AddOrUpdateSupplier from "./supplier-add-or-update";
import RfqTabBasic from "./rfq-tab-basic";
import RfqTabPart from "./rfq-tab-part";
import RfqTabFile from "./rfq-tab-file";
import RfqTabSupplier from "./rfq-tab-supplier";
import RfqTabPartPrice from "./rfq-tab-part-price";
import RfqTabCompare from "./rfq-tab-compare";
import RfqTabAudit from "./rfq-tab-audit";
import RfqBasicFormData from "./model/rfqbasicformdata";
import RfqPreparedApprove from "./rfq-prepared-approve";
import RfqTabTechSupplier from "./rfq-tab-techsupplier";
import QuotationDelayUpdate from './quotation-delay-update';
import QuotationNextTime from './quotation-next-time'
// 询价状态                 
// 新建 0       草稿(点发出通知结束) => 待询价 (发出询价) =>  询价中 (结束状态: 截至时间结束 OR 全部报价 ) =>  询价截至(已开标)  =>  1.发起下一轮  => 
//2.提交审批  => 通过/驳回 : 已定点/已驳回(可发起下一轮) 
// require('@/mock/mockRFQ');

const allowViewPriceStatusSet = new Set([
    RFQ_STATUS.COMPARING,
    RFQ_STATUS.EDITING,
    RFQ_STATUS.SUBMITTED,
    RFQ_STATUS.APPROVED,
    RFQ_STATUS.REJECT,
    RFQ_STATUS.DECIDED,
    RFQ_STATUS.PRICE_ARGUMENT,
    RFQ_STATUS.SPOT_PRICE,
])
const allowApproveStatusSet = new Set([
    RFQ_STATUS.EDITING,
    RFQ_STATUS.SUBMITTED,
    RFQ_STATUS.APPROVED,
    RFQ_STATUS.DECIDED,
])
export default {
    props: {

    },
    computed: {
        priceVisible() {
            return allowViewPriceStatusSet.has(this.dataForm.rfqStatus)
        },

        approveVisible() {
            return allowApproveStatusSet.has(this.dataForm.rfqStatus)
        }
    },
    data() {
        return {
            technicalId: '',
            loading: false,
            FILE_BIZ_TYPE: 13,
            FILE_BIZ_TYPE_SUPPLIER:17,
            // isPublish: false,
            // isPurchase: false,
            // inquireFormVisible: false,
            activeName: 'basicInfo',
            firstSupplierName: '',
            viewFlag: false,
            addOrUpdateSupplierVisible: false,
            userInfo: '',
            USER_TYPE: USER_TYPE,
            RFQ_STATUS: RFQ_STATUS,
            RFQ_STATUS_VALUE: getRFQ_STATUS_VALUE,
            SUPPLY_RFQ_STATUS_VALUE: getSUPPLY_RFQ_STATUS_VALUE,
            SUPPLY_TYPE_VALUE: getSUPPLY_TYPE_VALUE,
            viewData: {
                visible: false,
                width: ''
            },
            dataList: [],
            supplierList: [],
            techsupplierList: [],
            partList: [],
            rfqSupplierReplyStatus: '',
            dataForm: new RfqBasicFormData(),
            preparedApproveFlag:false,
            dataRule: {
                name: [{
                    required: true,
                    message: '组织名称不能为空',
                    trigger: 'blur'
                }],
                code: [{
                    required: true,
                    message: '组织代码不能为空',
                    trigger: 'blur'
                }],
                tenantName: [{
                    required: true,
                    message: '请先在页面顶部导航栏选择租户',
                    trigger: 'blur'
                }]
            },
            /**已选择的供应商 */
            checkedSupplierList: [],

            suppCleanList: [],
            preparedVisible: false,
            quotationDelayUpdateVisible: false,
            quotationNextTimeVisible: false,
            isStartNext: true,
            isShowComparePrice: false,
            purchasePartyAList: [],//采购组织数据集合
        }
    },
    components: {
        AddOrUpdateSupplier,
        RfqTabBasic,
        RfqTabSupplier,
        RfqTabPart,
        RfqTabCompare,
        RfqTabPartPrice,
        RfqTabFile,
        RfqTabAudit,
        RfqPreparedApprove,
        FilesUpDown1,
        FilesUpDown2,
        RfqTabTechSupplier,
        QuotationDelayUpdate,
        QuotationNextTime
    },
    mounted() {},
    methods: {
        close() {
            this.$emit('close')
            this.viewData.visible = false
        },
        getRFQdispStatus(type) {
            return getRFQ_STATUS_VALUE(type)
        },
        getCarType(value) {
            var carType = this.CAR_TYPE.find(obj => obj.value === Number(value))
            return carType ? carType.label : ''
        },
        view(data, id) {
            this.init(data, id)
        },
        getVisible(status) {
            return true
            // if (status) {
            //     return ![RFQ_STATUS.RFQSTART,
            //         RFQ_STATUS.BEFORE_ASK,
            //         RFQ_STATUS.ASKING
            //     ].includes(status)
            // } else {
            //     return false
            // }
        },
        async init(data, id, viewFlag) {
            if(data.rfqStatus == '2' && data.times > 1) {
                this.isShowComparePrice = true
            } else {
                this.isShowComparePrice = false
            }
            this.viewFlag = viewFlag
            this.technicalId = data ? data.technicalId : ''
            this.dataList = []
            this.supplierList = []
            this.techsupplierList = []
            this.vsupplierList = []
            this.partList = []
            this.dataForm = new RfqBasicFormData()
            this.userInfo = this.$store.state.user.userInfo
            this.dataForm.id = id || 0
            // this.dataForm.projectName = "XXXXXXXXXXXXX"
            // this.$nextTick(() => {
            // this.$refs['basicTab'].getFormRef().resetFields()
            // this.dataForm.tenantName = sessionStorage.getItem('tenantName')
            if (id) {

                // getRFQDetail({}, id).then(data => {
                //     if (data && data.code === '00') {
                //         this.dataForm = new RfqBasicFormData().init(data.body)
                //         this.dataForm.settingRfqStatus = this.dataForm.rfqStatus ? this.dataForm.rfqStatus : RFQ_STATUS.RFQSTART
                //     }
                // })
                try {
                    this.loading = true
                    await this.getBasicFormDetail()
                    await this.getSupplierList()
                    await this.getTechSupplierList()
                    // await this.getAppartmentList()
                    this.getPartList()
                    // if (this.priceVisible && this.supplierList && this.supplierList.length) {
                    //     this.$refs.appartmentRef.activeName = String(this.supplierLis[0].id)

                    // }
                    // await Promise.all([
                    //     this.getBasicFormDetail(),
                    //     this.getSupplierList(),
                    //     this.getAppartmentList(),
                    // ])
                } catch (e) {
                    console.error(e)
                    this.$message.error(`获取详情失败`)
                    console.log(e)
                } finally {
                    this.loading = false
                }
            }
            // this.dataForm.submitor = this.dataForm.submitor ? this.dataForm.submitor : this.userInfo.realName
            this.viewData.visible = true
            this.$nextTick(() => {
                if(this.viewFlag) {
                    this.$refs.FilesUpDown1.init("view");
                } else {
                    this.$refs.FilesUpDown1.init("edit");
                }
                // this.$refs.FilesUpDown2.init('view');
            })
        },

        /**获取基础信息详情 */
        async getBasicFormDetail() {
            try {
                await this.getPurchaseOrgListVue()
                const res = await getRFQDetail({}, this.dataForm.id)
                if (res && res.code === '00') {
                    this.dataForm = new RfqBasicFormData().init(res.body)
                    if (!this.dataForm.rfqStatus) this.dataForm.settingRfqStatus = RFQ_STATUS.RFQSTART
                } else {
                    this.$message.errow(`获取询价单详情失败`)
                }
            } catch (e) {
                console.error(e)
            }
        },
        // 查所有供应商表
        getPartList() {
            getRfqPartList({
                rfqId: this.dataForm.id,
            }).then((data) => {
                if (data && data.code === "00") {
                    if (data.body) {
                        this.partList = data.body
                    } else {
                        this.partList = []
                    }
                } else {
                    this.partList = []
                }
            })
        },
        // 查所有供应商表
        async getSupplierList() {
            try {
                const params = {
                    rfqId: this.dataForm.id,
                }
                const res = await getRfqSupplierList(params)
                if (res && res.code === "00" && Array.isArray(res.body)) {
                    debugger
                    this.supplierList = res.body
                    this.firstSupplierName = this.supplierList.length > 0 ? this.supplierList[0].id : ''
                    //判断推荐供应商回复状态和是否最终报价
                    /*this.supplierList.map(v => {
                        if(v.rfqSupplierReplyStatus == '3' || (v.rfqSupplierReplyStatus == '4' && v.lastFlag == 1)) {
                            this.isStartNext = false;
                        } else {
                            this.isStartNext = true;
                            //return;
                        }
                    })*/
                    for(var i = 0; i < this.supplierList.length; i++) {
                        var v = this.supplierList[i];
                        if(v.rfqSupplierReplyStatus == '3' || (v.rfqSupplierReplyStatus == '4' && v.lastFlag == 1)) {
                            this.isStartNext = false;
                        } else {
                            this.isStartNext = true;
                            break;
                        }
                    }
                } else {
                    this.supplierList = [];
                }
            } catch (e) {
                console.log(e)
            }

        },
        // 查定点申请供应商表
        async getTechSupplierList() {
            try {
                const params = {
                    technicalCode: this.dataForm.technicalCode,
                }
                const res = await getTechSupplierList(params)
                if (res && res.code === "00" && Array.isArray(res.body)) {
                    this.techsupplierList = res.body
                    this.firstSupplierName = this.techsupplierList.length > 0 ? this.techsupplierList[0].id : ''
                } else {
                    this.techsupplierList = [];
                }
            } catch (e) {
                console.log(e)
            }

        },
        // 查所有供应商表
        getCurrentSupplierStatus() {
            getRfqSupplierByUserId({
                userId: this.userInfo.id,
            }).then((data) => {
                if (data && data.code === "00") {
                    this.rfqSupplierReplyStatus = data.body.rfqSupplierReplyStatus;
                } else {
                    this.supplierList = [];
                }
            });
        },
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (!date) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD前")
        },
        dateFormatValue: function (value) {
            if (!value) {
                return ''
            }
            return moment(value).format("YYYY-MM-DD")
        },
        // joinSubmit() {
        //     this.dataForm.settingRfqStatus = RFQ_STATUS.RFQING
        //     // 更新供应商列表里的参与
        //     this.dataFormSubmit('参与成功')
        // },
        // giveupSubmit() {
        //     this.dataForm.settingRfqStatus = RFQ_STATUS.RFQING
        //     // 更新供应商列表里的状态放弃
        //     this.dataFormSubmit('已弃权')
        // },
        // makeRFQSubmit() {
        //     // console.log('test', this.dataForm)
        //     if (this.dataForm.rfqStatus === RFQ_STATUS.NEW) {
        //         this.dataForm.settingRfqStatus = RFQ_STATUS.BEGIN
        //         // 发出询价通知, 发邮件 通知供应商参与 提供技术方案 可以成为潜在供应商
        //         this.dataFormSubmit('发出询价通知函')
        //     } else {
        //         // 如果更应商都发完了
        //         // 发出询价函, 发邮件 通知潜在供应商可以报价
        //         this.dataForm.settingRfqStatus = RFQ_STATUS.BEFORE_ASK
        //         this.dataFormSubmit('发出报价通知函')
        //     }
        // },
        // 供应商采购员保存报价
        // saveQuotation() {
        //     // TODO: 每个供应商填写报价六张表
        //     // 附件文件上传
        //     this.dataFormSubmit('保存报价成功')
        // },
        // 采购员比较报价
        checkQuotation() {
            this.dataForm.settingRfqStatus = RFQ_STATUS.COMPARING
            this.dataFormSubmit('查看报价')
        },
        // // 采购员比较报价
        // compareQuotation() {
        //     this.dataForm.settingRfqStatus = RFQ_STATUS.ASKING
        //     this.dataFormSubmit('比价结束')
        // },
        // 采购员发起下一轮报价

        /**拟定审批单 */
        preparedApprove() {
            //this.preparedApproveFlag = true
            //先判断是否符合条件的中标供应商数据，如果没有则给提示，有的话再弹出选择界面
            getZBSupplierCountByRfqId({}, this.dataForm.id)
                .then((data) => {
                    if (data && data.code === "00") {
                        if(data.body == 0) {
                            this.$message.warning("没有报价的供应商，不能拟定审批单!");
                        } else if(data.body > 0) {
                            const summaryList = this.$refs.partInfo.summaryList

                            // const cleanList = summaryList.map(v => {
                            //     const item = JSON.parse(JSON.stringify(v))
                            //     item.share = 0
                            //     item.checked = false
                            //     return item
                            // })
                            //TODO 等后台数据连通了放开这层过滤  只需要取状态为已报价的供应商
                           const cleanList = summaryList.filter(v =>{
                                return v.rfqSupplierReplyStatus === '4'
                            })
                            this.suppCleanList = cleanList
                            this.preparedVisible = true
                            this.$nextTick(() => {
                                this.$refs.rfqPreparedApprove.init(cleanList,this.dataForm.id)
                                this.$refs.filesUpDown.init(this.viewFlag);
                            });
                        }
                    } else {
                        this.$message.error(data.msg);
                    }
                }).catch((error) => {
                    console.log(error);
                }).finally(() => {
                    //this.preparedApproveFlag = false
                })
        },
        async confirmQuotation() {
            // 调整中标供应商，发起下一轮
            // 修改，添加供应商
            const supplierData = this.$refs.compareInfo.getSupplierData()
            // const data = await editRfqPartPriceList(partData)
            const data = await editRfqSupplierList(supplierData)
            // 更细对应flag
            this.dataForm.settingRfqStatus = RFQ_STATUS.EDITING
            // TODO：发出询价通知，更新供应商状态
            this.dataFormSubmit('拟定审批单')
        },
        nextQuotation() {
            this.quotationNextTimeVisible = true
            this.$nextTick(() => {
                this.$refs.quotationNextTime.init(this.dataForm)
            });
        },
        tempQuotation() {
            // 调整中标供应商，发起下一轮
            // 修改，添加供应商
            this.dataForm.times = this.dataForm.times + 1
            // this.dataForm.settingRfqStatus = 0
            this.dataForm.settingRfqStatus = RFQ_STATUS.EDITING
            // TODO：发出询价通知，更新供应商状态
            this.dataFormSubmit('暂存审批单')
        },
        // 采购员商延期报价
        delayQuotation() {
            var rfqId = this.dataForm.id
            var rfq = this.dataForm
            this.quotationDelayUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.quotationDelayUpdate.init(rfq)
            });
        },
        // 采购员提交审批报价
        createApprove() {
            // 定厂是否通过，已经通过，直接审批
            // 是否修正目标价，生成生成招标审批单
            this.dataForm.settingRfqStatus = RFQ_STATUS.SUBMITTED
            this.dataFormSubmit('报价已提交审批')
        },
        // 批准
        // approve(flowTaskId, paramKey, paramVal) {
        // 选定通知书/落选通书发布
        // 是否为合格供应商
        // this.flowParam.flowTaskId = flowTaskId
        // this.flowParam.paramKey = paramKey
        // this.flowParam.paramVal = paramVal
        // this.dataForm.settingRfqStatus = RFQ_STATUS.APPROVED
        // this.dataFormSubmit('报价已批准')
        // },
        // 驳回
        // reject(flowTaskId, paramKey, paramVal) {
        // 是否调整中标供应商， 没有调整供应商可以提交审批
        // 驳回发起下一轮
        // 没有调整生成招标单
        // this.flowParam.flowTaskId = flowTaskId
        // this.flowParam.paramKey = paramKey
        // this.flowParam.paramVal = paramVal
        // this.dataForm.settingRfqStatus = RFQ_STATUS.REJECT
        // this.dataFormSubmit('报价已驳回')
        // },
        // 采购员定厂报价
        // chooseFactory() {
        // 用定厂的信息, 取供应商零件价格, 协议里维护价格有效期间, 和暂估标识
        // 暂估价传给sap
        // 量产价格走量产价格协议, 最新协议价格
        // 量产来源 定厂以后 选定厂协议
        // 采购路线

        // 订单分类
        // 样件订单有了, 采购, 采购部长, 技术, 质量? 审批, 确认, 创建ASN单生成ASN单号, 传ASN单-SAP 反SAP的单号 SRM保存
        // 量产订单 SAP拉取, 定期推, 供应商确认,不需要审批 , 创建ASN单生成ASN单号, 传ASN单-SAP 反SAP的单号 SRM保存
        // ASN单 根据订单信息生成交货单 -> 审批 
        // 量产 物流审批

        // this.isSelected = true
        // this.isContract = true
        // this.dataForm.settingRfqStatus = RFQ_STATUS.DECIDED
        // this.dataFormSubmit('定厂通知书发送成功')
        // this.$message({
        //     dangerouslyUseHTMLString: true,
        //     message: '1) 校验合格供应商<br/>2) 如果供应商信息不全，需要通知采购供应商走合格供应商流程。<br/>3) 供应商完善信息 <br/>4) 供应商管理员审批',
        //     type: 'warning'
        // });
        // },
        // makeContract() {
        //     // TODO: 按照供应商和零件列表创建多个合同
        //     this.dataForm.settingRfqStatus = RFQ_STATUS.CONTRACT
        //     this.dataFormSubmit('合同创建成功')
        //     // this.$message({
        //     //     message: '合同创建成功',
        //     //     type: 'success'
        //     // });
        // },

        savaBegin() {
            if (!this.dataForm.priceBit) {
                this.activeName = 'basicInfo'
                return this.$message.warning(`请填写价格小数点位数`)
            }
            if (!this.dataForm.quotationType) {
              this.activeName = 'basicInfo'
              return this.$message.warning(`请填写报价类型`)
            }
            if (!this.dataForm.quotationStopTime) {
                this.activeName = 'basicInfo'
                this.$message.warning(`请填写询价截至时间`)
                return
            }
            if (moment(this.dataForm.quotationStopTime).toDate().getTime() <= new Date().getTime()) {
                this.activeName = 'basicInfo'
                this.$message.warning(`询价截至时间应该大于当前时间`)
                return
            }
            //debugger
            if (!this.dataForm.purchaseOrgCode) {
                this.activeName = 'basicInfo'
                this.$message.warning(`请填写采购组织`)
                return
            }
            this.dataFormSubmit('保存成功!')

        },
        // 表单提交
        async dataFormSubmit(msg) {
            const params = this.dataForm
            //debugger
            if (this.dataForm.id) {
                try {
                    this.loading = true
                    const data = await editRFQ(params)
                    if (data && data.code === '00') {
                        this.dataForm = new RfqBasicFormData().init(data.body)
                        this.$message({
                            message: msg,
                            type: 'success',

                        })
                        this.$emit('refreshDataList')

                    } else {
                        this.$message.error(data.msg)
                    }
                } catch (e) {
                    console.error(e)
                } finally {
                    this.loading = false
                }
            } else {
                const data = await createRFQ(params)
                if (data && data.code === '00') {
                    this.dataForm = new RfqBasicFormData().init(data.body)
                    this.$message({
                        message: msg,
                        type: 'success',

                    })
                    this.$emit('refreshDataList')

                } else {
                    this.$message.error(data.msg)
                }
            }

        },
        // 新增 / 修改 供应商
        addOrUpdateSupplierHandle(id) {
            this.addOrUpdateSupplierVisible = true;
            this.$nextTick(() => {
                this.$refs.addOrUpdateSupplier.init(id, this.dataForm.id);
            });
        },

        // // 新增 / 修改 供应商
        // addOrUpdateVotedSupplierHandle(id) {
        //     // TODO：合格供应商需要接口
        //     console.log('VotedSupplier', id)
        // },

        // 删除供应商
        deleteSupplierHandle(id) {
            this.$confirm(`确定进行删除操作?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    deleteRfqSupplier({}, id)
                        .then((data) => {
                            if (data && data.code === "00") {
                                this.$message({
                                    message: "操作成功",
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.getSupplierList();
                                    },
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                })
                .catch(() => {});
        },
        // 改变标签
        async changeTab() {
            if (this.activeName === 'compareInfo') {
                this.$nextTick(() => {

                    const comp = this.$refs[this.activeName]
                    // if(!comp || comp.dataInitd) return
                    comp.currTab = 'summary'
                    comp.handleCheckTabClick()
                })
                // comp.getApplierSummaryList(this.dataForm.id)
                // comp.getPriceList(this.dataForm.id)
            }
            if (this.activeName === 'partInfo') {
                //TODO 默认加载比价信息栏数据
                this.$refs[this.activeName].activeName = '0'
                this.$refs[this.activeName].getPriceList(this.supplierList[0].id)
            }
        },
        changeSelectSupplier(rows) {
            this.checkedSupplierList = rows

        },
        // 通知询价
        informAsk() {
            if (this.dataForm.rfqStatus === RFQ_STATUS.BEGIN) {
                //debugger
                if (!this.dataForm.priceBit) {
                    this.activeName = 'basicInfo'
                    return this.$message.warning(`请填写价格小数点位数`)
                }
                if (!this.dataForm.quotationStopTime) {
                    this.activeName = 'basicInfo'
                    this.$message.warning(`请填写询价截至时间`)
                    return
                }
                if (moment(this.dataForm.quotationStopTime).toDate().getTime() <= new Date().getTime()) {
                    this.activeName = 'basicInfo'
                    this.$message.warning(`询价截至时间应该大于当前时间`)
                    return
                }
                //草稿状态 判断是否已经添加过供应商
                if (this.supplierList.length && this.supplierList.length > 0) {
                    //TODO 后台需要向已添加的所有供应商发送邮件,成功后改状态至 => 待询价
                    this.dataForm.times = 1
                    this.dataForm.settingRfqStatus = RFQ_STATUS.BEFORE_ASK
                    this.dataFormSubmit('发出询价通知函')
                } else {
                    this.$message.warning(`请至少添加一家供应商`)
                }
            } else if (this.dataForm.rfqStatus === RFQ_STATUS.BEFORE_ASK) {
                if (Array.isArray(this.checkedSupplierList)) {
                    if (this.checkedSupplierList.length === 0) {
                        this.$message.warning(`请至少选择一家供应商进行通知`)
                    } else {
                        //TODO 单独通知接口
                        // try{
                        this.dataForm.times = 1
                        this.dataForm.settingRfqStatus = RFQ_STATUS.ASKING
                        this.dataFormSubmit('发出询价通知函')
                        // }
                    }
                }
            }
            return
        },
        // 发出询价
        postAsk() {
            if (Array.isArray(this.checkedSupplierList)) {
                this.activeName = 'supplierInfo'
                if (this.checkedSupplierList.length === 0) {
                    this.$message.warning(`请至少选择一家供应商`)
                } else {
                    //TODO
                    this.dataForm.settingRfqStatus = RFQ_STATUS.ASKING
                    this.dataFormSubmit('发出报价通知函')
                    //TODO 请求接口
                    // try{

                    // }
                }
            }
            return
        },
        //保存拟定审批单
        async confirmPrepare(params) {
            //debugger
            let rfqAuditType = "1"
            if(this.dataForm.rfqType === "0") {
                rfqAuditType = "1"
            } else if(this.dataForm.rfqType === "1") {
                rfqAuditType = "2"
            } else if(this.dataForm.rfqType === "2") {
                rfqAuditType = "3"
            } else if(this.dataForm.rfqType === "3") {
                rfqAuditType = "4"
            }else if(this.dataForm.rfqType === "4") {
              rfqAuditType = "5"
            }
            //TODO zhao: 选择完的供应商id 及 份额 在params里
            // id: 供应商id, share: 份额(%) Number
            //此处应该请求接口保存 并改变状态为待提交。
            const param = {
                rfqId : this.dataForm.id,
                rfqAuditType : rfqAuditType,
                rfqAuditStatus : '新建',
                rfqAuditName : this.dataForm.rfqName + '审批单',
                rfqPartDTOList : params,
                times : this.dataForm.times
            }
            const data = await generateAudit(param)
            if (data && data.code === '00') {
                this.$message({
                    message: '拟定审批单成功',
                    type: 'success',

                })
                this.$emit('refreshDataList')

            } else {
                this.$message.error(data.msg)
            }
            this.viewData.visible = false
        },
        //保存延期报价日期
        async confirmDelayDate(param) {
             this.dataForm.settingDelayTimes = this.dataForm.delayTimes + 1
             this.dataForm.quotationStopTime = param
             this.dataFormSubmit('延期报价成功')
        },
        //保存下一轮报价截止日期
        async confirmNextDelayDate(param) {
             // 调整中标供应商，发起下一轮
             // 修改，添加供应商
             this.activeName = 'basicInfo'
             this.dataForm.settingTimes = this.dataForm.times + 1
             this.dataForm.quotationStopTime = param
             // this.dataForm.settingRfqStatus = 0
             this.dataForm.settingRfqStatus = RFQ_STATUS.ASKING
             // TODO：发出询价通知，更新供应商状态
             this.dataFormSubmit('发起下一轮报价')
        },
        // 采购组织数据
        getPurchaseOrgListVue() {
          getCurrentUserPurOrg({
                purchaseOrgCode: '',
                purchaseOrgName: '',
            }).then((data) => {
                if (data && data.code === '00') {
                this.purchasePartyAList = data.body
                }
            })
        },
    }
}
</script>

<style lang="scss">
.el-dialog__body {
    .org-dialog-form {
        width: 95%;
    }
}

.linetext {
    white-space: pre-line;
}

.button-danger {
    color: #F56C6C
}

.rfq-dialog>.el-dialog__body {
    min-height: 600px;
}
.tab_style {
    min-height: 35vh;
}
</style>
